<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <v-text-field label='Address' v-model='value.address'></v-text-field>
      </v-col>
      <v-col cols='12' sm='8'>
        <v-text-field label='City' v-model='value.city'></v-text-field>
      </v-col>
      <v-col cols='12' sm='4'>
        <v-text-field label='Province' v-model='value.province'></v-text-field>
      </v-col>
      <v-col cols='12' sm='8'>
        <v-text-field label='Country' v-model='value.country'></v-text-field>
      </v-col>
      <v-col cols='12' sm='4'>
        <wc-postal-code-input v-model='value.postal'></wc-postal-code-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'client-details-form',
  props: {
    value: {
      required: true
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
